import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs';

export class HashedTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    const hashedUrl = `/assets/i18n/${lang}.${environment.i18nHash}.json`;
    const fallbackUrl = `/assets/i18n/${lang}.json?v=${environment.i18nHash}`;

    return this.http
      .get(hashedUrl)
      .pipe(catchError(() => this.http.get(fallbackUrl)));
  }
}
